import { Injectable } from '@angular/core';
import {
  CrmEnvelope,
  CrmSignatureModuleService,
} from 'common-module/signature';
import { PlCardRoutes } from '@app/pages/pl-cards/plcard.routes';
import { AppRoutes } from '@app/app.routes';

@Injectable({ providedIn: 'root' })
export class SignatureService extends CrmSignatureModuleService {
  protected override showDocumentPreview(envelope: CrmEnvelope) {
    this.router.navigate([
      AppRoutes.plcards,
      envelope._id,
      PlCardRoutes.review,
    ]);
  }
}
